import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Dictionary } from '../../models/models';
import { ModalErrorComponent } from '../modal-error/modal-error.component';

@Component({
  selector: 'modal-set-status-component',
  templateUrl: './modal-set-status.component.html'
})
export class ModalSetStatusComponent {
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() statuses: Dictionary[];
  newStatusId: number;
  newStatusName: string;
  @Input() statusName: string;
  @Input() noStatusError: string;

  constructor(public activeModal: NgbActiveModal,
    private modalService: NgbModal) { }

  ngOnInit() {
  }

  save() {
    if (this.newStatusId) {
      for (var i = 0; i < this.statuses.length; i++) {
        if (this.statuses[i].value == this.newStatusId) {
          this.newStatusName = this.statuses[i].name;
        }
      }

      this.passEntry.emit({ statusId: this.newStatusId, statusName: this.newStatusName });
      this.activeModal.close();
    }
    else {
      const modalRef = this.modalService.open(ModalErrorComponent);
      modalRef.componentInstance.errors = [this.noStatusError];
    }
  }
}
